import { Col, Row, Typography, theme } from "antd";
import { useCurrentUser } from "hooks/useCurrentUser";
import type React from "react";
import { useIntl } from "react-intl";
import { Link, useLocation, useParams } from "react-router-dom";
import { EntitySelect } from "./components/EntitySelect";
import { SeasonSelect } from "./components/SeasonSelect";

const { useToken } = theme;

export const BreadCrumbs = () => {
  const { token } = useToken();
  const { formatMessage } = useIntl();
  const { customerId, sport, organizationId, entityId, seasonId } = useParams();
  const location = useLocation();
  const currentUser = useCurrentUser();

  const breadcrumb: React.ReactNode[] = [];

  const createArrow = (key: string) => (
    <i key={key} className="fa-solid fa-chevron-right ml-15 mr-15" style={{ color: token.colorError }} />
  );
  const createItem = (key: string, title: string, linkUrl?: string) => {
    if (linkUrl) {
      return (
        <Link key={key} to={linkUrl}>
          <Typography.Text style={{ color: token.colorPrimary }} strong>
            {title}
          </Typography.Text>
        </Link>
      );
    }

    return (
      <Typography.Text key={key} style={{ color: token.colorPrimary, fontWeight: 700 }}>
        {title}
      </Typography.Text>
    );
  };

  breadcrumb.push(createItem("bc-brand-name", formatMessage({ id: "breadcrumbs.sportradar" })));
  breadcrumb.push(createArrow("bc-arrow-1"));
  breadcrumb.push(createItem("bc-link-to-home", formatMessage({ id: "breadcrumbs.teamManager" }), "/"));

  if (organizationId) {
    breadcrumb.push(createArrow("bc-arrow-2"));

    if (currentUser.organization) {
      breadcrumb.push(createItem("bc-link-to-organization", currentUser.organization.nameLocal, `/${customerId}`));
    } else {
      breadcrumb.push(createItem("bc-link-to-organizations", formatMessage({ id: "breadcrumbs.organizations" }), "/"));
    }
  }

  if (location?.pathname.includes("admin")) {
    breadcrumb.push(createArrow("bc-arrow-3"));
    breadcrumb.push(
      createItem(
        "bc-link-to-admin-dashboard",
        formatMessage({ id: "breadcrumbs.adminDashboard" }),
        `/${customerId}/${sport}/${organizationId}/admin`
      )
    );
  } else {
    if (entityId) {
      breadcrumb.push(createArrow("bc-arrow-4"));
      breadcrumb.push(<EntitySelect key="bc-entity-select" />);
    }

    if (seasonId) {
      breadcrumb.push(createArrow("bc-arrow-5"));
      breadcrumb.push(<SeasonSelect key="bc-search-select" />);
    }
  }

  return (
    <Row>
      <Col span={24}>{breadcrumb?.map((item) => item)}</Col>
    </Row>
  );
};
